import { render, staticRenderFns } from "./CheckboxIcon.vue?vue&type=template&id=1ee120dc&scoped=true"
import script from "./CheckboxIcon.vue?vue&type=script&lang=ts"
export * from "./CheckboxIcon.vue?vue&type=script&lang=ts"
import style0 from "./CheckboxIcon.vue?vue&type=style&index=0&id=1ee120dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee120dc",
  null
  
)

export default component.exports